export default "__VITE_PUBLIC_ASSET__162f6816__"